import { VueModule } from '@Foundation/utilities';
import SafetyStandard from './code/Scripts/components/safety-standard';

export default VueModule({
  components: {
    SafetyStandard
  }
});
